import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import NotFound from '../Pages/Helpers/404'
import useIngestAccess from '../services/hooks/useIngestAccess'
import { ButtonOutline } from '../Components/GeneralComponents/ButtonOutline/ButtonOutline'
import classes from './IngestRoute.module.css'

export default function IngestRoute({ children }) {
  const access = useIngestAccess()

  if ([401, 403].includes(access.error?.status)) return <NotFound />

  // Nothing at all while the check is in flight. It resolves in about 100ms,
  // so any placeholder is a flash of the wrong page rather than feedback.
  if (access.isLoading) return null

  if (access.error) {
    return (
      <div className={classes.shell}>
        <h1 className={classes.title}>Ingest</h1>
        <div className={classes.panel}>
          <p className={classes.message} role="alert">
            Ingestion access could not be checked. Please try again.
          </p>
          <div className={classes.actions}>
            <ButtonOutline
              color="pink"
              size="small"
              disable={access.isFetching}
              text="Check again"
              onClick={() => access.refetch()}
            />
            <Link to="/artists" className={classes.back}>
              Back to artists
            </Link>
          </div>
        </div>
      </div>
    )
  }

  if (!access.data?.enabled) {
    return (
      <div className={classes.shell}>
        <h1 className={classes.title}>Ingest</h1>
        <div className={classes.panel}>
          <p className={classes.message}>Temporal ingestion is not enabled in this environment yet.</p>
          <div className={classes.actions}>
            <Link to="/artists" className={classes.back}>
              Back to artists
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return children
}

IngestRoute.propTypes = { children: PropTypes.node }
